import { GET_ADDVENDOR_FAILED, GET_ADDVENDOR_REQUESTED, GET_ADDVENDOR_SUCCESS, GET_UPDATEVENDOR_FAILED, GET_UPDATEVENDOR_REQUESTED, GET_UPDATEVENDOR_SUCCESS, GET_VENDOR_FAILED, GET_VENDOR_REQUESTED, GET_VENDOR_SUCCESS, GET_VENDORUSER_FAILED, GET_VENDORUSER_REQUESTED, GET_VENDORUSER_SUCCESS } from "resources/actionTypes";


const initialState = {
  userVendor: [],
  loading: false,
  error: null,
};
const initialStateAdd = {
  userAddVendor: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateVendor: [],
  loading: false,
  error: null
}

const initialStateUser = {
  userVendorUser:[],
  loading: false,
  error: null,
}

export function userVendor(state = initialState, action) {
  switch (action.type) {
    case GET_VENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userVendor: action.userVendor,
      };
    case GET_VENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddVendor(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_ADDVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddVendor: action.userAddVendor,
      };
    case GET_ADDVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateVendor(state = initialStateUpdate, action) {
  switch (action.type) {
    case GET_UPDATEVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATEVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateVendor: action.userUpdateVendor,
      };
    case GET_UPDATEVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userVendorUser(state = initialStateUser, action) {
  switch (action.type) {
    case GET_VENDORUSER_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_VENDORUSER_SUCCESS:
      return {
        ...state,
        loading: false,
        userVendorUser: action.userVendorUser,
      };
    case GET_VENDORUSER_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
